<section class="content" xmlns="">
  <div class="container-fluid">
    <div class="row">
      <div class="row mt-3">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="form-floating mb-3">
              <select class="form-select" (change)="selectValue($event)">
                <option value="">Select a Event Name</option>
                <option *ngFor="let event of this.eventDetails" [value]="event.eventId">{{event.eventName}} -
                  {{event.city}} -
                  {{formattedDate(event?.eventDate)}} {{ showThankYouMail(event) ? ',( Completed)' : '' }}</option>
                <!-- <option value="192">CIFA Surabhi - Indian Classical Dance Performance - Aug-3</option>
                <option value="180">CIFA Surabhi - Indian Classical Dance Performance - Sep-14</option> -->
              </select>
              <label for="formId1">Event Name</label>
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="form-floating mb-3">
              <input type="text" [(ngModel)]="searchText" class="form-control"
                placeholder="Search by Name, Email or Phone Number">
              <label>Search</label>
            </div>
          </div>
        </div>

        <div class="row align-items-center">

          <!-- Left Section -->
          <div class="col-12 col-md-8 mb-3 mb-md-0">
            <div class="d-flex flex-column gap-2">
              <h5 class="font-weight-bold mb-0">
                No of Booked : {{getListOfWorkshopDetails.length}}
              </h5>

              <h5 class="font-weight-bold mb-0">
                No of Participants Booked : {{participantBookingCount}}
              </h5>
            </div>

          </div>

          <!-- Right Section -->
          <div class="col-12 col-md-4 text-md-end">
            <button class="btn btn-success w-100 w-md-auto" (click)="generateExcelSheet()">
              Generate Excel
            </button>
          </div>

        </div>



        <mat-card class="order-card">
          <div class="container-fluid">
            <div class="row">
              <mat-card-content>
                <div class="container-fluid mt-1">
                  <div class="table-responsive table-style table-bordered">
                    <table class="table table-gray table-head-fixed">
                      <thead class="h6">
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Sub Participants Name</th>
                          <th>City</th>
                          <th>Phone Number</th>
                          <th>Email ID</th>
                          <th>Booked Date</th>
                          <th>Ticket Number</th>
                          <!-- <th>Payment Status</th>
                          <th>Payments Details</th> -->
                        </tr>
                      </thead>
                      <tbody *ngIf="getListOfWorkshopDetails.length > 0; else noDataFound">
                        <tr class="text-center"
                          *ngFor="let work of getListOfWorkshopDetails | filter : searchText; let i = index;">
                          <td>{{ i + 1 }}</td>
                          <td>{{work?.name || "-"}}</td>
                          <td>
                            {{ getSubParticipantsNames(work?.audienceDetails) }}
                          </td>

                          <td>{{work?.district || "-"}}</td>
                          <td>{{work?.phoneNumber || "-"}}</td>
                          <td>{{work?.emailId || "-"}}</td>
                          <td>{{work?.createdAt | date : "MM/dd/yyyy"}}</td>
                          <td>
                            <a [href]="getTicketUrl(work?.audienceDetails[0]?.ticketSeq)" target="_blank"
                              class="text-primary fw-bold" data-bs-toggle="tooltip" title="Click to view ticket"
                              class="text-primary" style="cursor:pointer; text-decoration: underline;">

                              {{ work.audienceDetails[0].ticketSeq }}

                            </a>
                          </td>

                        </tr>
                      </tbody>
                      <ng-template #noDataFound>
                        <tr>
                          <td colspan="11" class="text-center fw-bold">Data Not Found</td>
                        </tr>
                      </ng-template>
                    </table>
                  </div>
                </div>
              </mat-card-content>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</section>


<div class="modal" tabindex="-1" [style.display]="paymentDetailModal ? 'block' : 'none'"
  style="background-color: rgba(87,86,86,0.64)">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header modal-header-bg m-3">
        <div class="row mb-3">
          <h4 class="modal-title fw-bolder">{{ regName }}</h4>
          <h6 class="mt-2 fw-bold">{{ phoneNumber }}</h6>
        </div>
      </div>
      <div class="modal-body">
        <div class="container-fluid mt-3">
          <div class="table-responsive table-style table-bordered">
            <table class="table table-gray table-head-fixed">
              <thead class="h6">
                <tr>
                  <th>S.No</th>
                  <th>Transaction ID</th>
                  <th>Total Amount</th>
                  <th>payment Via</th>
                  <th>Payment Date</th>
                  <th>status</th>
                </tr>
              </thead>
              <tbody class="text-center" *ngIf="this.transactionDetails.length > 0;else noDataFound">
                <tr *ngFor="let trans of this.transactionDetails; let i = index;">
                  <td>{{ i + 1 }}</td>
                  <td>{{ trans.transactionId }}</td>
                  <td>$ {{ trans.amount| currency:'US':'' }}</td>
                  <td> {{ trans.createdAt| date:'MM/dd/yyyy':'' }}</td>
                  <td>{{ trans.paymentVia }}</td>
                  <td>
                    <span class="badge" [ngClass]="{'badge-gradient-red': trans.status == 'OnError', 'badge-gradient-green': trans.status == 'COMPLETED',
                        'badge-gradient-info': trans.status == 'OnCancel'}">{{ trans.status }}</span>
                  </td>
                </tr>
              </tbody>
              <ng-template #noDataFound>
                <tr>
                  <td colspan="5" class="text-center fw-bold">Data Not Found</td>
                </tr>
              </ng-template>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" aria-label="Close"
          (click)="paymentDetailModal = false">Close
        </button>
      </div>
    </div>
  </div>
</div>